export const CONTACT_US_FORM_FIELDS = {
    firstName: "firstName",
    lastName: "lastName",
    emailAddress: "emailAddress",
    phoneNumber: "phoneNumber",
    topic: "topic",
    companyName: "companyName",
    message: "message",
    emailTo: "emailTo",
    productId: "productId",
    productName: "productName",
    productNumber: "productNumber",
    productUrl: "productUrl",
    productImage: "productImage",
    attachment: "attachment",
    city: "city",
    state: "state",
    country: "country",
} as const;
